import {
  STOCK_TAKING_CAR_MANAGEMENT_SALES_TYPE_CATALOG_BEGIN,
  STOCK_TAKING_CAR_MANAGEMENT_SALES_TYPE_CATALOG_SUCCESS,
  STOCK_TAKING_CAR_MANAGEMENT_SALES_TYPE_CATALOG_FAILURE
  } from '../constants'
  
  export function reducer(state, action) {
    switch (action.type) {
      case STOCK_TAKING_CAR_MANAGEMENT_SALES_TYPE_CATALOG_BEGIN:
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            getSalesTypeCatalogsPending: true,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                saleOptions: [],
                saleOptionsError: null
            }
          }
        }
      case STOCK_TAKING_CAR_MANAGEMENT_SALES_TYPE_CATALOG_SUCCESS:
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            getSalesTypeCatalogsPending: false,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                saleOptions: action.data,
                saleOptionsError: null
            }
          }
        }
      case STOCK_TAKING_CAR_MANAGEMENT_SALES_TYPE_CATALOG_FAILURE:
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            getSalesTypeCatalogsPending: false,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                saleOptions: [],
                saleOptionsError: action.data.error
            }
          }
        }
      default:
        return state
    }
  }
  